//src/pages/TermsPage.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { getTermsConditionsSettings } from "../services/homepage.api";

function TermsPage() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
const [loading, setLoading] = useState(true);

  const TEXT = {
    EN: {
      mainPage: "Main page",
      velle: "ETIKA",
      fallbackTitle: "Terms and conditions",
    },
    AR: {
      mainPage: "الصفحة الرئيسية",
      velle: "ETIKA",
      fallbackTitle: "الشروط والأحكام",
    },
  }[lang];

  useEffect(() => {
  let mounted = true;

  setLoading(true);

  getTermsConditionsSettings()
    .then((data) => {
      if (mounted) setSettings(data);
    })
    .catch(() => {
      if (mounted) setSettings(null);
    })
    .finally(() => {
      if (mounted) setLoading(false);
    });

  return () => {
    mounted = false;
  };
}, []);

  const title =
    lang === "AR"
      ? settings?.title_ar || TEXT.fallbackTitle
      : settings?.title_en || TEXT.fallbackTitle;

  const content =
    lang === "AR" ? settings?.content_ar || "" : settings?.content_en || "";

    const emptyContent =
  lang === "AR"
    ? "لم يتم إضافة محتوى هذه الصفحة بعد."
    : "No content has been added to this page yet.";

  const blocks = String(content || emptyContent)
    .split(/\n{2,}/)
    .map((x) => x.trim())
    .filter(Boolean);

    if (loading) {
  return (
    <div
      className="w-full min-h-screen bg-white overflow-x-hidden"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <TopBanner />
      <MainHeader />

      <main className="bg-white px-4 md:px-8 md:pt-[175px]">
        <div className="max-w-5xl mx-auto pb-14">
          <div className="h-4 w-[240px] bg-gray-200 animate-pulse rounded mb-8" />
          <div className="h-10 w-[320px] bg-gray-200 animate-pulse rounded mb-8" />

          <div className="space-y-7">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="space-y-3">
                <div className="h-5 w-[40%] bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-full bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[92%] bg-gray-200 animate-pulse rounded" />
                <div className="h-5 w-[75%] bg-gray-200 animate-pulse rounded" />
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

  return (
    <div
      className="w-full min-h-screen bg-white overflow-x-hidden"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <TopBanner />
      <MainHeader />

      <main className="bg-white px-4 md:px-8 md:pt-[175px]">
        <div className="max-w-5xl mx-auto pb-14">
          {/* BREADCRUMB */}
          <div className="text-[12px] md:text-sm text-gray-900 mb-8">
            <button
              type="button"
              onClick={() => {
                navigate("/");
                setTimeout(() => window.scrollTo({ top: 0, left: 0 }), 0);
              }}
              className="hover:text-black hover:underline"
            >
              {TEXT.mainPage}
            </button>

            <span className="mx-2">›</span>
            <span>{TEXT.velle}</span>
            <span className="mx-2">›</span>
            <span className="text-gray-900">{title}</span>
          </div>

          <h1 className="text-[30px] md:text-[38px] font-normal text-black mb-8">
            {title}
          </h1>

          <div className="space-y-7 text-[17px] md:text-[18px] leading-8 text-black">
            {blocks.map((block, index) => {
              const lines = block.split("\n").map((line) => line.trim());

              return (
                <div key={index}>
                  {lines.map((line, lineIndex) => {
                    const isHeading =
                      line.endsWith(":") ||
                      lineIndex === 0 && lines.length > 1;

                    return (
                      <p
                        key={lineIndex}
                        className={isHeading ? "font-bold mb-1" : ""}
                      >
                        {line}
                      </p>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default TermsPage;